<template>
    <div class="m-rebate">
        <h5 class="title"></h5>

        <div class="view">
            <div class="skin-view">
                <div class="list-1">
                    <ul class="skin-list">
                        <li v-for="(item,index) in skin_config['list']" :key="index"  @click="$item_tips(item.id)">
                            <game-item :id="item.id" :locked="true"></game-item>
                            <div class="status" :class="{'act' : skin_status[item.id.toLowerCase() + '_flag'] == 1}"></div>
                        </li>
                    </ul>
                </div>
                <div class="list-2">
                    <div class="skin-item" @click="$item_tips(skin_config['now'].id)">
                        <game-item :id="skin_config['now'].id" :locked="true"></game-item>
                        <div class="status" :class="{'act' : skin_status['skin_flag'] == 1}"></div>                        
                    </div>
                </div>
            </div>

            <div class="info">
                <h6 class="info-title"></h6>
                <div class="text">
                    <p>太史慈*请叫我鸡王、邓艾*天命之子、布小蛮*布鸡道、梦*蔡文姬*</p>
                    <p>闻鸡破晓激活其一，再激活孙策*天命狐王</p>
                    <p>即可获得【大吉大利鸡王宝藏】</p>
                </div>
            </div>

            <div class="reward-view">
                <h6 class="reward-name"></h6>

                <div class="reward-list">
                    <ul>
                        <li v-for="(item,index) in pack_config" :key="index">
                            <div class="reward-item" @click="$item_tips(item.id)"><game-item :id="item.id" :num="item.num" :locked="true"></game-item></div>                           
                            <!-- <div class="item-name">{{ item.name }}</div>                        -->
                        </li>
                    </ul>
                </div>

                <div class="u-btn apply" :class="{'disabled' : (!skin_status['skin_flag'] && $store.state.userinfo.areaId) || ($store.state.account.uflag & 4) == 4}" @click="apply_pack(4)"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
h5.title{
    width: 479px;
    height: 72px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/title-shop-1.png);
}

.skin-view{
    display: flex;
    justify-content: space-between;
    margin-bottom: 18px;
}

.skin-view .list-1{
    width: 513px;
    height: 155px;
    background-image: url(~@/assets/images/bg-skin-list-1.png);
}

.skin-view .list-2{
    width: 183px;
    height: 155px;
    background-image: url(~@/assets/images/bg-skin-list-2.png);
}

.skin-list{
    display: flex;
    align-items: center;
    height: 100%;
}

.list-1 .skin-list{
    padding-left: 71px;
    padding-right: 31px;
    justify-content: space-between;
}

.list-2{
    display: flex;
    align-items: center;    
    justify-content: center;
}

.skin-item .pic{
    margin: 0 auto;
}

.status{
    position: relative;
    width: 20px;
    height: 20px;
    margin: 10px auto 0;
    background-image: url(~@/assets/images/skin-circel.png);
}

.status.act::after{
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 10px;
    height: 10px;
    margin-top: -5px;
    margin-left: -5px;
     background-image: url(~@/assets/images/skin-act.png);  
}

.info-title{
    width: 150px;
    height: 27px;
    margin: 0 0 10px;
    background-image: url(~@/assets/images/title-evt-info.png);    
}

.reward-view{
    position: relative;
    width: 530px;
    height: 315px;
    padding: 20px 63px 0;
    box-sizing: border-box;
    margin-top: 28px;
    background-image: url(~@/assets/images/bg-reward-1.png);  
}

.reward-view::after{
    content: '';
    display: block;
    position: absolute;
    right: -350px;
    top: -175px;
    width: 418px;
    height: 603px;
    background-image: url(~@/assets/images/layer-char-1.png);  
    transform: scale(.9);
}

.reward-name{
    width: 239px;
    height: 31px;
    margin: 0 auto 45px;
    background-image: url(~@/assets/images/title-pack-1.png);  
}

.reward-list ul{
    display: flex;
    justify-content: space-between;
}

.reward-list li .reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 84px;
    height: 84px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-item.png);    
}

.item-name{
    width: 120px;
    margin-top: 5px;
    text-align: center;
}

.u-btn.apply{
    position: absolute;
    width: 225px;
    height: 60px;
    left: 50%;
    bottom: 34px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/btn-apply.png);
}

.u-btn.apply.disabled{
    background-image: url(~@/assets/images/btn-apply-disabled.png);
}
</style>

<script>
export default {
    data (){
        return {
            skin_config : {
                list : [{id : 'FL70',name : ''},{id : 'FN22',name : ''},{id : 'FN38',name : ''},{id : 'FP40',name : ''},],
                now : {id : 'FP94',name : ''},
            },
            pack_config : [{id : 'D774',name : '珍宝自选珍材宝箱(7天)',num : 2},{id : 'AG00',name : '高级士兵卡',num : 1},{id : 'Y552',name : '神鸡妙算',num : 1},],
            skin_status : () => {},
        }
    },
    mounted (){
        if(this.$store.state.userinfo.uid)this.query_skin();
        //console.log(this.$store.state.account.uflag & 64)
    },
    methods : {
        apply_pack(gid){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if(!this.skin_status.skin_flag)return this.$toast('领取条件未达成，请检查封灵玉是否已激活');

            if((this.$store.state.account.uflag & gid) == gid)return this.$toast('无法再领取');

            this.$axios.post(ajax_url_map.apply,{
                code : gid,
            })
            .then(
                res => {
                    this.$success_Apply();
                    this.$store.commit("$_setFlag", gid); 
                    //TODO
                    //task_update
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },
        query_skin (){
            //if(!this.$store.state.login)return;
            this.$axios.get(ajax_url_map.skin)
            .then(
                res => {
                    this.skin_status = res.data;
                }
            )
        },
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/Shop/rebate.vue